export class Pagination {
    itemsPorPagina!: number;
    numeroPagina!: number;
    palabraClave?: string;
    rolId?: number;
    tipoFiltroId?: number;
    dtFechaInicial?: Date;
    dtFechaFinal?: Date;
    vcClase?: string;
    claseId?: number;
    solicitudId?: number;
}